import {CARRIER_CALLSIGN} from './config'

export const getUserCallsign = (id: string) => {
  return CARRIER_CALLSIGN + id
}
